import styled from 'styled-components';

export const StyledButtonRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px 0;

  button,
  a {
    white-space: nowrap;
    text-transform: uppercase;
    margin-right: 20px;
  }
`;
